////////////////////////////////////////////////////////////
//  Program: PetCleaningFee.jsx                           //
//  Application: KINI HTML                                //
//  Option: Pet Cleaning Fee                              //
//  Developer: AK 	                                      //
//  Date: 2026-02-03                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import CommonHeader from "../common/CommonHeader";
import Moment from "moment";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PetCleaningFeeForm from "./PetCleaningFeeForm";
import CmsDataService from "../../services/CmsDataService";
import ReservationService from "../../services/ReservationService";
import { Spinner } from "react-bootstrap";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import queryString from "query-string";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class PetCleaningFee extends Component {
  constructor(props) {
    super(props);
    const queryParams = queryString.parse(props.location?.search || "");
    const tripDetailsRaw = localStorage.getItem("trip_details");
    let tripDetails = null;
    try {
      tripDetails = tripDetailsRaw ? JSON.parse(tripDetailsRaw) : null;
    } catch (e) {
      tripDetails = null;
    }
    this.state = {
      currentData: tripDetails,
      headerToken: localStorage.getItem("headerToken")
        ? localStorage.getItem("headerToken")
        : "",
      is_form_submited: localStorage.getItem("is_form_submited")
        ? localStorage.getItem("is_form_submited")
        : "",
      pet_cleaning_fee: localStorage.getItem("pet_cleaning_fee")
        ? localStorage.getItem("pet_cleaning_fee")
        : "",
      today: Moment(new Date()).format("YYYY-MM-DD H:m:s"),
      maxPet: 5,
      no_of_pet: 1,
      no_of_pet_error: "",
      webview: queryParams.webview ? queryParams.webview : 1,
      confirmation_code:
        props.match && props.match.params
          ? props.match.params.confirmationCode
          : "",
      quantitySelect: true,
    };
    this.getReservationDetails = this.getReservationDetails.bind(this);
    this.getclientToken = this.getclientToken.bind(this);
  }

  async componentDidMount() {
    await this.getReservationDetails();
  }

  onBackButtonEvent = () => {
    this.props.history.push("/reservation-list");
  };

  getReservationDetails = async () => {
    this.setState({ loader: true, tokenError: "", errorMsg: "" });
    try {
      const data = {
        confirmation_code: this.state.confirmation_code,
        last_name: "",
        email: "",
        property_seo_slug: "",
        user_slug: "",
        filter_by: 4,
      };
      const res = await ReservationService.getMyBookReservation(data);
      const reservationData = res?.data;
      const isSuccess = this.getSuccessStatusList().includes(res?.status);
      const hasData = this.isReservationDataValid(reservationData);

      if (!isSuccess || !hasData) {
        this.setState({
          loader: false,
          errorMsg:
            "Details entered by you are incorrect. Please verify your confirmation code and last name you have used during booking.",
        });
        return;
      }

      const bookedPets = parseInt(reservationData?.pets, 10);
      const nextState = {
        currentData: reservationData,
        total_record: reservationData?.total || 0,
        reservationList: reservationData,
        reservation_slug: reservationData?.slug || "",
        guest_slug: reservationData?.guest_user?.slug || "",
        customer_id: reservationData?.guest_user?.stripe_customer_id || "",
        reservationDetail: true,
        errorMsg: "",
        loader: false,
        ...(Number.isFinite(bookedPets) && bookedPets >= 1 && bookedPets <= this.state.maxPet
          ? { no_of_pet: bookedPets }
          : {}),
      };

      localStorage.setItem("trip_details", JSON.stringify(reservationData));
      this.setState(nextState, () => {
        // this.getclientToken();
      });
    } catch (error) {
      this.setState({
        loader: false,
        errorMsg: "Unable to load reservation details. Please try again.",
      });
    }
  };

  getSuccessStatusList = () => {
    if (
      Array.isArray(globalThis?.successStatus) &&
      globalThis.successStatus.length
    ) {
      return globalThis.successStatus;
    }
    return [200, 201];
  };

  isReservationDataValid = (reservationData) => {
    if (!reservationData) {
      return false;
    }
    if (Array.isArray(reservationData)) {
      return reservationData.length > 0;
    }
    return (
      typeof reservationData === "object" &&
      Object.keys(reservationData).length > 0
    );
  };

  getBasePetCleaningFee = () => {
    const amount = parseFloat(this.state.currentData?.pet_cleaning_fee_stripe);
    return Number.isFinite(amount) && amount > 0 ? amount : 0;
  };

  formatAmount = (amount = 0) => {
    const safeAmount = Number.isFinite(Number(amount)) ? Number(amount) : 0;
    return globalThis?.OnKeyPressEvent?.numberWithCommasForDecimal
      ? globalThis.OnKeyPressEvent.numberWithCommasForDecimal(
          safeAmount.toFixed(2).replace(/\.00$/, ""),
        )
      : safeAmount.toFixed(2);
  };

  resetPaymentSession = () => {
    this.setState({
      clientToken: "",
      stripe_id: "",
      petCleaningAmount: 0,
      quantitySelect: true,
    });
  };

  getclientToken = async () => {
    const quantity = parseInt(this.state.no_of_pet, 10) || 1;
    if (quantity < 1 || quantity > this.state.maxPet) {
      this.setState({
        no_of_pet_error: `Please select between 1 and ${this.state.maxPet} pets`,
      });
      return;
    }

    const basePetAmount = this.getBasePetCleaningFee();
    const petCleaningAmount = Number((quantity * basePetAmount).toFixed(2));
    if (petCleaningAmount <= 0) {
      this.resetPaymentSession();
      this.setState({
        tokenError: "Invalid pet cleaning fee amount. Please contact support.",
      });
      return;
    }

    this.setState({
      showSpinner: true,
      loading: true,
      loader: true,
      quantitySelect: false,
      tokenError: "",
    });
    try {
      const inputData = {
        customer_id: this.state.currentData?.guest_user?.stripe_customer_id,
        payment: petCleaningAmount,
        guest_slug: this.state.currentData?.guest_user?.slug,
        reservation_slug: this.state.currentData?.slug,
        quantity: quantity,
      };
      const res = await CmsDataService.getPetCleaningclientToken(inputData);
      let clientToken = "";
      let stripe_id = "";
      if (this.getSuccessStatusList().includes(res?.status)) {
        clientToken = res?.data ? res.data[0] : "";
        stripe_id = res?.data ? res.data[1] : "";
      }

      if (clientToken && stripe_id) {
        this.setState({
          clientToken,
          stripe_id,
          petCleaningAmount,
          quantitySelect: false,
        });
      } else {
        this.resetPaymentSession();
        this.setState({
          tokenError: "Unable to initialize payment. Please try again.",
        });
      }
    } catch (error) {
      this.resetPaymentSession();
      this.setState({
        tokenError: "Unable to initialize payment. Please try again.",
      });
    } finally {
      this.setState({
        showSpinner: false,
        loading: false,
        loader: false,
      });
    }
  };

  handleChange = (event) => {
    const selectedValue = parseInt(event.target.value, 10);
    const { maxPet } = this.state;
    if (
      !Number.isFinite(selectedValue) ||
      selectedValue < 1 ||
      selectedValue > maxPet
    ) {
      this.setState({
        no_of_pet_error: `Please select between 1 and ${maxPet} pets`,
      });
      return;
    }

    this.setState({
      no_of_pet: selectedValue,
      no_of_pet_error: "",
      tokenError: "",
      clientToken: "",
      stripe_id: "",
      petCleaningAmount: 0,
      quantitySelect: true,
    });
  };

  render() {
    const selectedNoOfPet = parseInt(this.state.no_of_pet, 10) || 1;
    const unitPetAmount = this.getBasePetCleaningFee();
    const totalAmount = Number((unitPetAmount * selectedNoOfPet).toFixed(2));
    const displayUnitAmount = this.formatAmount(unitPetAmount);
    const displayTotalAmount = this.formatAmount(totalAmount);
    const options = {
      // passing the client secret obtained in step 3
      clientSecret: this.state.clientToken,
      // Fully customizable with appearance API.
      appearance: {
        /*...*/
      },
    };
    return (
      <>
        <main className="oh-template Brandmainpage wizard_header wzard_main_bg parking_via_web">
          {this.state.webview === 1 ? <CommonHeader /> : ""}
          <section className="wizard_sec">
            <div className="row- wizard_row m-0 mobV iew">
              <div className="wizard_box ">
                <div className="wizard-data req_book_secw-zaed">
                  <div className="container-fluid p-0 parking_page">
                    <section className="wzrd_main_section">
                      <div className="container">
                        <div className="content">
                          <div className="row mobView wizard_new_heading">
                            <div
                              className={
                                this.state.quantitySelect === true
                                  ? "wzrd_middle_desk park-full"
                                  : "wzrd_middle_desk2"
                              }
                            >
                              <div className="col-sm-12 col-lg-12 bg_wzrd_heading mob_sticky_top">
                                <div className="wzrd_heading_box col-12 m-0 ">
                                  <h4>
                                    {this.state.currentData
                                      ?.pet_cleaning_screen_stripe_titles
                                      ? this.state.currentData
                                          ?.pet_cleaning_screen_stripe_titles
                                      : "Pet Cleaning Payment"}
                                  </h4>
                                </div>
                              </div>
                              <div className="col-sm-12 col-lg-12 bg_wzrd_heading ">
                                <div className="wzrd_heading_box col-12 mb-0">
                                  <div className="col-xs-12 col-sm-12 col-md-12 p-0 mg-b-0 upload_info_detail ">
                                    <p>
                                      {" "}
                                      <b className="doc_upload_heading pt-0 parking-head-text">
                                        Would you like to add the Pet Cleaning
                                        Fee for ${displayUnitAmount} per pet?
                                      </b>{" "}
                                    </p>
                                    <ul className="parking_list_sty p-0">
                                      <p>
                                        This is a one-time fee charged to cover
                                        additional cleaning required for stays
                                        with pets.
                                      </p>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                                <div className="parking_price_box">
                                  <div className="wzrd_heading_box col-12 ">
                                    <div className="wzrd_mid_heading pt-0 border-0">
                                      <h5 className="pt-0">
                                        pet cleaning price details
                                      </h5>
                                      <div className="mt-3">
                                        <ul className="parking_pay_detail">
                                          <li>
                                            <span>
                                              ${displayUnitAmount} per Pet
                                            </span>
                                            <span>${displayUnitAmount}</span>
                                          </li>

                                          <li>
                                            <span>No. of Pet</span>
                                            {this.state.quantitySelect ===
                                            true ? (
                                              <>
                                                <FormControl
                                                  error={
                                                    !!this.state.no_of_pet_error
                                                  }
                                                >
                                                  <Select
                                                    className="parking_car"
                                                    id="demo-simple-select"
                                                    label="No. of Pet"
                                                    value={this.state.no_of_pet}
                                                    name="no_of_pet"
                                                    onChange={this.handleChange}
                                                  >
                                                    <MenuItem disabled value="">
                                                      Select number of pet
                                                    </MenuItem>
                                                    {Array.from(
                                                      {
                                                        length:
                                                          this.state.maxPet,
                                                      },
                                                      (_, i) => i + 1,
                                                    ).map((value) => (
                                                      <MenuItem
                                                        key={value}
                                                        value={value}
                                                      >
                                                        {value}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                </FormControl>
                                                {this.state.no_of_pet_error && (
                                                  <p
                                                    style={{
                                                      color: "red",
                                                      marginTop: "4px",
                                                    }}
                                                  >
                                                    {this.state.no_of_pet_error}
                                                  </p>
                                                )}
                                              </>
                                            ) : (
                                              <span>
                                                {this.state.no_of_pet
                                                  ? this.state.no_of_pet
                                                  : 1}
                                              </span>
                                            )}
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div className="wzrd_mid_heading pt-0 ">
                                      <div className="parking_total">
                                        <ul className="parking_pay_detail">
                                          <li className="parking_total_price">
                                            <span>Total (USD)</span>
                                            <span>${displayTotalAmount}</span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    {!!this.state.tokenError && (
                                      <p className="error-message">
                                        {this.state.tokenError}
                                      </p>
                                    )}
                                    {this.state.quantitySelect === true && (
                                      <div className="mg-t-30 reservationBook bg-white">
                                        <button
                                          className="w-100"
                                          disabled={this.state.loader}
                                          onClick={() => this.getclientToken()}
                                        >
                                          Proceed for payment{" "}
                                          {this.state.loader ? (
                                            <>
                                              <Spinner
                                                as="span"
                                                animation="grow"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                              <Spinner
                                                as="span"
                                                animation="grow"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                              <Spinner
                                                as="span"
                                                animation="grow"
                                                role="status"
                                                aria-hidden="true"
                                              />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {this.state.quantitySelect === false && (
                                <div className="col-sm-12 col-lg-12 bg_wzrd_heading">
                                  <div className="wzrd_heading_box col-12 mb-0">
                                    <div className="col-xs-12 col-sm-12 col-md-12 mg-b-0 strip_parking">
                                      {!this.state.clientToken ? (
                                        this.state.quantitySelect === false && (
                                          <div>
                                            <h3>Loading...</h3>
                                          </div>
                                        )
                                      ) : (
                                        <div className="col-xs-12 col-sm-12 col-md-12 pd-l- pd-r-">
                                          <Elements
                                            stripe={stripePromise}
                                            options={options}
                                          >
                                            <PetCleaningFeeForm
                                              guest_slug={
                                                this.state.currentData
                                                  ?.guest_user?.slug
                                              }
                                              reservation_slug={
                                                this.state.currentData?.slug ||
                                                ""
                                              }
                                              amount={
                                                this.state.petCleaningAmount
                                                  ? this.state.petCleaningAmount
                                                  : totalAmount
                                              }
                                              stripe_id={this.state.stripe_id}
                                              confirmation_code={
                                                this.state.currentData
                                                  ?.confirmation_code
                                              }
                                              no_of_pet={this.state.no_of_pet}
                                            />
                                          </Elements>
                                        </div>
                                      )}
                                      <p className="error-message"></p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* )} */}
        </main>
      </>
    );
  }
}
export default PetCleaningFee;
